import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UseFullPageLoaderHook from "../Modals/Hook/UseFullPageLoaderHook";

const styles = {
  hintBox: {
    background: "#fff9e6",
    border: "1px solid #ffe9a8",
    padding: "10px 15px",
    borderRadius: "8px",
    fontSize: "14px",
    color: "#7a5b00",
    display: "inline-block",
    width: "100%",
    marginTop: "12px",
    textAlign: "center",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: "8px",
    marginBottom: "10px",
    borderBottom: "1px solid #e1e1e1",
  },
  infoBanner: {
    background: "#fff3cd",
    padding: "12px 16px",
    borderRadius: "8px",
    fontSize: "14px",
    color: "#856404",
    lineHeight: "1.5",
    marginTop: "10px",
  },
  modalScrollArea: {
    height: "600px",
    maxHeight: "600px",
    overflowY: "scroll",
  },
  missingShirtNumber: {
    color: "red",
    fontWeight: "600",
  },
};

const ErrorLabel = ({ error }) =>
  error ? <span className="text-danger">{error}</span> : null;

const PlayerRows = ({ rows, abbreviation }) =>
  rows.map((player, index) => {
    const hasShirt = Boolean(player.shirtNumber);
    return (
      <tr key={index}>
        <td>{player.playerId}</td>

        <td style={!hasShirt ? styles.missingShirtNumber : {}}>
          {hasShirt ? player.key : "Missing shirt #"}
        </td>

        <td>
          {player.currentScore !== undefined && player.currentScore !== null
            ? Math.round(player.currentScore * 100) / 100
            : ""}
        </td>
      </tr>
    );
  });

const TeamTable = ({ title, abbreviation, rows }) => (
  <Col>
    <div style={styles.sectionHeader}>
      <h4 style={{ margin: 0 }}>
        {title} ({abbreviation})
      </h4>
    </div>

    <Table striped bordered hover>
      <thead>
        <tr>
          <th>Player</th>
          <th>Current Score</th>
        </tr>
      </thead>

      <tbody>
        <PlayerRows rows={rows} abbreviation={abbreviation} />
      </tbody>
    </Table>
  </Col>
);

const PlayerDetailsModal = ({ show, onHide, fixtureDetails }) => {
  const [rowsDataHome, setRowsDataHome] = useState([]);
  const [rowsDataAway, setRowsDataAway] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loader] = UseFullPageLoaderHook();

  useEffect(() => {
    if (!fixtureDetails) return;

    const mapPlayers = (players) =>
      (players || []).map((p) => ({
        playerId: p.playerId,
        key: p.key,
        shirtNumber: p.shirtNumber,
        currentScore: p.currentScore,
      }));

    setRowsDataHome(mapPlayers(fixtureDetails?.homeTeamPlayers));
    setRowsDataAway(mapPlayers(fixtureDetails?.awayTeamPlayers));
  }, [fixtureDetails]);

  const handleClose = () => {
    onHide();
    setErrorMessage(null);
  };

  return (
    <>
      <Modal
        size="xl"
        show={show}
        onHide={handleClose}
        centered
        backdrop="static"
        dialogClassName="player-detail-modal-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Player Details</h3>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={styles.modalScrollArea}>
          <Row>
            <TeamTable
              title={`Home - ${fixtureDetails?.homeTeam?.name}`}
              abbreviation={fixtureDetails?.homeTeam?.abbreviation}
              rows={rowsDataHome}
            />

            <TeamTable
              title={`Away - ${fixtureDetails?.awayTeam?.name}`}
              abbreviation={fixtureDetails?.awayTeam?.abbreviation}
              rows={rowsDataAway}
            />
          </Row>

          <Row className="mt-2">
            <Col>
              <ErrorLabel error={errorMessage} />
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {loader}
    </>
  );
};

export default PlayerDetailsModal;
